import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { Routing } from './Screens/Routing';
import { Theme, applyTheme } from '@cloudscape-design/components/theming';
import { themeObject } from './Screens/tokenStyle/tokeReset';
import { initRum } from '../src/hooks/rum';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const theme: Theme = themeObject;
const { reset } = applyTheme({ theme });
initRum();
root.render(<Routing />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
//TODO add back strict mode
